<div class="menu" [ngClass]="{'menu-website' : typeIsWebsite}" >
  <div class="menu-header">
    <a href="/" class="header-logo">
      <img [ngSrc]="'/assets/images/logo.png'" width="100" height="22" priority="true" alt="Nuu logo" />
    </a>

    <app-button
      [config]="{
        view: 'icon',
        icon: {
          name: 'closeOutlined',
        },
      }"
      (click)="close()"
    ></app-button>
  </div>

  @if (!typeIsWebsite) {
    @if (userType === 'employee' && user?.user_profile.company?.search_name) {
      <nav class="navigation">
        <ul class="navigation-list">
          <li class="navigation-item">
            <a [routerLink]="['/', companySearchName, 'dashboard']"
              (click)="close()"
              class="navigation-link">
              {{ 'COMPANY.NAVBAR.DASHBOARD' | translate }}
            </a>
            @if ((notifications$ | async)?.applications) {
              <span class="badge"
                [@smoothFade]
                >
                {{ (notifications$ | async)?.applications }}
              </span>
            }
          </li>
          <li class="navigation-item">
            <a [routerLink]="['/', companySearchName]"
              (click)="close()"
              class="navigation-link"
              >
              {{ 'COMPANY.NAVBAR.COMPANY_PROFILE' | translate }}
            </a>
          </li>
          @if (webHelper.isHasWriteAccess(user)) {
            <li
              class="navigation-item">
              <a [routerLink]="['/' + companySearchName + '/meldinger']"
                (click)="close()"
                class="navigation-link"
                >
                {{ 'COMPANY.NAVBAR.NOTIFICATIONS' | translate }}
              </a>
              @if ((notifications$ | async)?.messages) {
                <span class="badge"
                  [@smoothFade]
                  >
                  {{ (notifications$ | async)?.messages }}
                </span>
              }
            </li>
          }
          @if (user.user_profile.companies.length >= 2) {
            <li
              class="navigation-item">
              <a [routerLink]="['/', 'company-select']"
                (click)="close()"
                class="navigation-link"
                >
                {{ 'COMPANY.NAVBAR.COMPANY_SELECT' | translate }}
              </a>
            </li>
          }
          <li class="navigation-item">
            <a [routerLink]="['/' + companySearchName + '/settings/personal']"
              (click)="close()"
              class="navigation-link"
              >
              {{ 'COMPANY.NAVBAR.SETTINGS' | translate }}
            </a>
          </li>
          <li class="navigation-item">
            <a [routerLink]="['/' + companySearchName + '/support']"
              (click)="close()"
              class="navigation-link"
              >
              {{ 'COMPANY.NAVBAR.SUPPORT' | translate }}
            </a>
          </li>
        </ul>
        @if (getUserRole(user) === USER_ROLE.ADMIN ||
          getUserRole(user) === USER_ROLE.RECRUITER) {
          <app-button
      [config]="{
        view: 'primary',
        label: 'COMPANY.NAVBAR.CREATE_JOB',
        classes: 'width-full'
      }"
            (click)="close(); router.navigate(['/', companySearchName, 'opprett-stilling'])"
            >
          </app-button>
        }
      </nav>
    }
    @if (userType === 'applicant') {
      <nav class="navigation">
        <ul class="navigation-list">
          <li class="navigation-item">
            <a [routerLink]="['/bruker']"
              (click)="close()"
              class="navigation-link">
              {{ 'USER.MENU.DASHBOARD' | translate }}
            </a>
          </li>
          <li class="navigation-item">
            <a [routerLink]="['/bruker/video-cv-er']"
              (click)="close()"
              class="navigation-link">
              {{ 'USER.MENU.VIDEO_CV' | translate }}
            </a>
          </li>
          <li class="navigation-item">
            <a [routerLink]="['/bruker/meldinger']"
              (click)="close()"
              class="navigation-link">
              {{ 'USER.MENU.NOTIFICATIONS' | translate }}
            </a>
            @if ((notifications$ | async)?.messages) {
              <span class="badge"
                [@smoothFade]
                >
                {{ (notifications$ | async)?.messages }}
              </span>
            }
          </li>
          <li class="navigation-item">
            <a [routerLink]="['/bruker/endre-profil']"
              routerLinkActive="active-link"
              (click)="close()"
              class="navigation-link">
              {{ 'USER.MENU.EDIT_PROFILE' | translate }}
            </a>
          </li>
          <li class="navigation-item">
            <a [routerLink]="['/kontakt']"
              routerLinkActive="active-link"
              (click)="close()"
              class="navigation-link">
              {{ 'COMPONENTS.MENU.CONTACTS' | translate }}
            </a>
          </li>
        </ul>
      </nav>
    }
  }

  @if (typeIsWebsite) {
    <nav class="navigation">
      <ul class="navigation-list">
        <li class="navigation-item">
          <app-industries-menu [view]="'mobile'"
            (onSelect)="close()"
          ></app-industries-menu>
        </li>
        <li class="navigation-item">
          <a
            [href]="'https://nuu.no/nuu'"
            target="_blank"
            (click)="close()"
            class="navigation-link">
            {{ 'COMMON.CAREER' | translate}}
          </a>
        </li>
        <li class="navigation-item">
          <a [routerLink]="['/funksjonaliteter']"
            (click)="close()"
            class="navigation-link">
            {{ 'FUNCTIONALITY.LABEL' | translate }}
          </a>
        </li>
        <li class="navigation-item">
          <a [routerLink]="['/contact']"
            (click)="close()"
            class="navigation-link">
            {{ 'COMMON.CONTACT' | translate }}
          </a>
        </li>
      </ul>
    </nav>
  }

  <div class="menu-footer">
    @if (typeIsWebsite) {
      <div class="buttons">
        <app-button
          class="price-btn"
          [config]="{
            view: 'primary',
            label: 'COMMON.PRICE' | translate
          }"
          [routerLink]="['/price']"
          (click)="close()">
        </app-button>

        <app-button
          class="login-btn"
          [config]="{
            view: 'outlined',
            label: 'COMMON.LOGIN' | translate
          }"
          [routerLink]="['/login']"
          (click)="close()">
        </app-button>
      </div>
    }

    <div class="languages">
      @for (lang of languages; track lang) {
        <a
          class="language"
          [class.language-active]="lang.code === activeLanguage"
          (click)="selectLanguage(lang)"
          >
          {{ lang.name }}
        </a>
      }
    </div>

    @if (user) {
      <div class="logout">
        <a (click)="webHelper.logout(); close()" class="nav-item">{{ 'COMMON.LOGOUT' | translate }}</a>
      </div>
    }
  </div>
</div>
